import React from 'react';
import { ChevronRight, Trash2, GripVertical } from 'lucide-react';

const moduleMeta = {
  introduction: { label: 'Introduction', summary: null, removable: false },
  'skill-conversations': {
    label: 'Skill conversations',
    summary: (m) => {
      const count = (m.skills || []).filter((s) => s.name.trim()).length;
      return `# of skills: ${count}   |   Duration: ${count * 5} Min`;
    },
    removable: true,
  },
  'custom-questions': {
    label: 'Custom questions',
    summary: (m) => {
      const count = (m.questions || []).length;
      const dur = (m.questions || []).reduce((s, q) => s + (Number(q.time) || 0), 0);
      return `# of questions: ${count}   |   Duration: ${dur} min`;
    },
    removable: true,
  },
  exercise: {
    label: 'Exercise',
    summary: (m) => `Type of exercise: ${m.exerciseType || 'custom'}   |   Duration: ${m.duration || 0} min`,
    removable: true,
  },
  'resume-conversation': {
    label: 'Resume portion',
    summary: (m) => `Duration: ${m.duration ?? 15} min`,
    removable: true,
  },
  'language-assessment': {
    label: 'Language assessment',
    summary: (m) => {
      const code = (m.language || 'en-us').split('-')[0];
      const short = code.charAt(0).toUpperCase() + code.slice(1);
      return `Language: ${short}   |   Duration: ${m.duration ?? 10} min`;
    },
    removable: true,
  },
};

export default function FlowList({ flow, selectedId, onSelect, onRemove }) {
  return (
    <div>
      <p className="text-[12.5px] text-[#4A4463] mb-3">
        You can reorder modules to set your interview flow.
      </p>

      <div className="space-y-2.5">
        {flow.map((m) => {
          const meta = moduleMeta[m.type] || { label: m.type };
          const active = selectedId === m.id;
          return (
            <div
              key={m.id}
              className={`group flex items-stretch rounded-xl border bg-white overflow-hidden ${
                active ? 'border-[#5B4FE8] ring-2 ring-[#5B4FE8]/20' : 'border-[#ECE6FA]'
              }`}
            >
              <div className="flex items-center px-2 bg-[#F5F1FE] text-[#8A83A5]">
                <GripVertical size={14} />
              </div>
              <button
                onClick={() => onSelect(m.id)}
                className="flex-1 text-left px-3 py-3"
              >
                <div className="flex items-center justify-between">
                  <span className="text-[13.5px] font-semibold text-[#1A1533]">{meta.label}</span>
                  <ChevronRight size={14} className="text-[#8A83A5]" />
                </div>
                {meta.summary && (
                  <div className="text-[11.5px] text-[#6B6485] mt-1">{meta.summary(m)}</div>
                )}
              </button>
              {meta.removable && (
                <button
                  onClick={() => onRemove(m.id)}
                  className="px-3 flex items-center text-[#DC3545] hover:bg-[#FDECEC]"
                  aria-label="Remove module"
                >
                  <Trash2 size={15} />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
